import React from 'react';

import { Field } from 'redux-form';

import { TREKKSOFT, EXPEDIA, BOOKING } from 'constants/userSettings';
import { Input } from 'components';
import TrekksoftCategoriesMapping from '../trekksoft-categories-mapping/TrekkSoftCategotiesMapping';

import { useStyles } from './styles';

const IntegrationsInputFields = ({ field, integrationPlatform }) => {
  const classes = useStyles();

  return (
    <div className={classes.inputRow}>
      {integrationPlatform === TREKKSOFT && (
        <div className={classes.formWrapper}>
          <Field
            name={`${field}.merchantName`}
            className={classes.merchantName}
            placeholder="Merchant name"
            label="Merchant name *"
            component={Input}
          />
          <div className={classes.inputRow}>
            <Field
              name={`${field}.apiClientId`}
              className={classes.input}
              placeholder="API client id"
              label="API client id *"
              component={Input}
            />
            <Field
              name={`${field}.apiClientSecret`}
              className={classes.input}
              placeholder="API client secret"
              label="API client secret *"
              component={Input}
            />
          </div>
        </div>
      )}
      {(integrationPlatform === EXPEDIA || integrationPlatform === BOOKING) && (
        <div className={classes.inputRow}>
          <Field
            name={`${field}.username`}
            className={classes.input}
            placeholder="Username"
            label="Username *"
            component={Input}
          />
          <Field
            name={`${field}.password`}
            className={classes.input}
            placeholder="Password"
            label="Password *"
            type={'password'}
            component={Input}
          />
        </div>
      )}

      {integrationPlatform === TREKKSOFT && <TrekksoftCategoriesMapping />}
    </div>
  );
};

export default IntegrationsInputFields;
